module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-left-panel-1-f12091c7eefd3db690710ddfcca9c10a.svg";